import React from "react";
import { Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";

function Team() {
  return (
<>

    <Row className="team-row-equal">
      <Col xs={12} md={4} className="team-col-equal mb-4 mb-md-0">
        <div className="borderCols1 br-teal101 team-card-equal">
          <div style={{ padding: "20px" }}><h8>Founders</h8></div>
          <p style={{ fontSize: "12px", textAlign: "justify", padding: "10px", paddingBottom: "45px" }}>
            Visionary Indicudiuals with a passion for leveraging technology to improve life. <br />
            Understand and capitalise on emerging opportunities to incorporate to fontana space. <br />
            Committed to improve Fontana ecosystem.
          </p>
        </div>
      </Col>
      <Col xs={12} md={4} className="team-col-equal mb-4 mb-md-0">
        <div className="borderCols1 br-teal101 team-card-equal">
          <div style={{ padding: "20px" }}><h8>Experts</h8></div>
          <p style={{ fontSize: "12px", textAlign: "justify", padding: "10px" }}>
            To ensure the sustainable and robust development of the Lumina Metaverse and the Cerulean DAO, Fontana will engage specialist economic consultants during the inception of Metaverse and DAO. These consultants
            will provide expert guidance on the economic models, governance structures, and incentive mechanisms that will underpin these crucial components of the Fontana ecosystem.
          </p>
        </div>
      </Col>
      <Col xs={12} md={4} className="team-col-equal">
        <div className="borderCols1 br-teal101 team-card-equal">
          <div style={{ padding: "20px" }}><h8>Developers</h8></div>
          <p style={{ fontSize: "12px", textAlign: "justify", padding: "10px", paddingBottom: "45px" }}>
            Our aim is to engage with individuals/ organizations who are passionate about pushing the boundaries of blockchain technology and creating innovative solutions.
            We partner with results-oriented freelance/agency blockchain and  developers dedicated to building cutting-edge decentralized applications.
          </p>
        </div>
      </Col>
    </Row>

    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="team-quote-text">
            "Lets' build worlds that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Fontana Team</footer>
        </blockquote>
      </Card.Body>
    </Card>
    </>
  );
}

export default Team;
